import { Button, Col, Modal, ModalBody, Row } from "react-bootstrap"
import ModalHeader from "react-bootstrap/esm/ModalHeader"
import CompanyInput from "../../FormattedInputs/CompanyInput"
import { useState } from "react"
import { Spinner } from "react-bootstrap"
import { finalize } from "rxjs/operators"
import { toast } from "react-toastify"
import { NoAccountAcceptObservable } from "../../../api/OrphanedResults/ResultExceptionsProcess"
import FormatError from "../../../formatters/FormatError"
import OrphanedRow from "../../../api/OrphanedResults/Models/OrphanedRow"
import { DraggableModalDialog } from "../../Randomization/GovPools/RandomSchedulingExclusionsModal"

interface AccountNotFoundErrorProps {
  errorRow: OrphanedRow
  onClose: (withUpdate: boolean) => void
}

function AccountNotFoundError(props: AccountNotFoundErrorProps) {
  const { errorRow, onClose } = props
  const [ AccountID, setAccountID ] = useState(0)
  const [ saving, setSaving ] = useState(false)

  const onCancel = () => {
    onClose(false);
  }

  const onAccept = () => {
    setSaving(true)
    NoAccountAcceptObservable(errorRow.LabAccountNumber, AccountID, errorRow.TestDetailImportID, errorRow.TestImportExceptionID)
    .pipe(finalize(() => setSaving(false)))
    .subscribe(
      data => {
        toast.success(data)
        onClose(true)
      },
      error => toast.error(FormatError(error))
    )
  }

  return (
    <Modal dialogAs={DraggableModalDialog} show size="lg" dialogClassName="dark" onHide={onClose}>
      <ModalHeader closeButton>Account Not Found Error</ModalHeader>
      <ModalBody>
        <Row>
          <Col className="mt-1">
            Select the company that owns this lab account
          </Col>
          <Col>
            <CompanyInput onChange={ selected => setAccountID(selected[0]?.AccountID) }/>
          </Col>
        </Row>
        <Row>
          <Col>
            <b>{errorRow.LabAccountNumber}</b>
          </Col>
        </Row>
      </ModalBody>
      <Modal.Footer>
        {saving && <Spinner animation="border" />}
        {!saving && <>
          <Button variant="primary" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onAccept} disabled={!AccountID}>
            Accept
          </Button>
        </>}
      </Modal.Footer>
    </Modal>
  )
}

export default AccountNotFoundError
